import React, { FC } from 'react'
import './RegisterPreview.scss'
import RegisterWrapperCard from '../RegisterWrapperCard/RegisterWrapperCard'
import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import { IRegisterDataForm } from 'app_types/register/registerTypes'
import ButtonComponent from 'app_components/commons/Button/ButtonComponent'

interface IRegisterPreviewProps {
  formData?: IRegisterDataForm
  onBack: () => void
  onNext: () => void
}

const RegisterPreview: FC<IRegisterPreviewProps> = ({ formData, onBack, onNext }) => {
  return (
    <RegisterWrapperCard title='Registro'>
      <div className="register-preview--layout">
        <TextComponent fontSize={18} fontWeight={400}>
          Verifica tus datos
        </TextComponent>
        <div className='register-preview--data-container'>
          <TextComponent>Nombre: {formData?.firstName}</TextComponent>
          <TextComponent>Apellido: {formData?.lastName}</TextComponent>
          <TextComponent>Tipo de documento: {formData?.documentType}</TextComponent>
          <TextComponent>Documento de identidad: {formData?.documentNumber}</TextComponent>
          <TextComponent>Correo electrónico: {formData?.email}</TextComponent>
        </div>
        <div className="register-preview--actions">
          <ButtonComponent
            border='1px solid var(--secondary)'
            textTransform='initial'
            paddingTop={11}
            paddingBottom={11}
            fontSize={18}
            onClick={onBack}
            color='var(--secondary)'
          >
            Corregir

          </ButtonComponent>
          <ButtonComponent
            variant='secondary'
            textTransform='initial'
            paddingTop={12}
            paddingBottom={12}
            fontSize={18}
            onClick={onNext}
          >
            Continuar
          </ButtonComponent>
        </div>
      </div>
    </RegisterWrapperCard>
  )
}

export default RegisterPreview
